import { KeycloakService } from 'keycloak-angular';
import { environment } from '../environments/environment';
import { PerfilControleService } from './service/perfil-controle.service';

export const initializer = (keycloak: KeycloakService, perfilControleService: PerfilControleService): () => Promise<boolean> => (): Promise<boolean> => keycloak.init({
  config: {
    url: environment.urlKeycloak,
    realm: 'mctic',
    clientId: 'sepin'
  },
  initOptions: {
    onLoad: 'login-required',
    checkLoginIframe: false
  },
  enableBearerInterceptor: true,
  bearerExcludedUrls: ['/example'],
  loadUserProfileAtStartUp: true
}).then((): any => {
  return perfilControleService.carregarPerfis();
});
